export const dateFormat = 'Do MMM YYYY';
export const timeFormat = 'H:mm';

export const dateTimeFormat = 'Do MMM YYYY, HH:mm';

export const isPathMatched = (string, pattern) => {
  if (typeof pattern === 'function') {
    return pattern(string);
  } else if (typeof pattern === 'string') {
    return string === pattern;
  }
  return false;
};

export const regExCheckUnsubscribePage = /^\/contact\/[0-9a-f]{24}\/unsubscribe$/i;
export const standAlonePages = [
  (path) => regExCheckUnsubscribePage.test(path),
  '/auth/callback',
  '/outreach-journey',
];

export const contactRouteMatch = (value) => {
  return /^\/tasks\/[^\/]+$/.test(value);
};

export const taskRouteMatch = (value) => {
  return /^\/task\/[^\/]+$/.test(value);
};

export const specialCharacterRegex = (value) => {
  return !/[^a-zA-Z0-9 ]/.test(value);
};

export const contactNameRegex = (value) => {
  // return true;
  return /^[a-zA-Z\x7f-\xff-']+$/.test(value);
  // return !/^[A-Za-zÀ-ÖØ-öø-ÿ\s-']+$/.test(value);
};

export const checkValueExists = (value, data, key = null) => {
  if (!value || typeof value !== 'string') {
    return false;
  }

  for (let i = 0; i < data.length; i++) {
    const itemValue = key ? data[i]?.[key] : data[i]; // Safely access data[i][key]

    if (
      typeof itemValue === 'string' &&
      itemValue.trim().toLowerCase() === value.trim().toLowerCase()
    ) {
      return true;
    }
  }
  return false;
};

export const authPages = [
  '/auth/login',
  '/auth/setup/password',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/signup',
  '/auth/verification',
  '/auth/onboarding/password',
];

export const girdLoadingMessages = [
  'we are loading your data',
  "we'll be right with you",
  'getting everything ready',
  'loading your info',
  "we're loading your data",
  'putting everything together',
];

export const instagramRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com)\/(\w+)/;
export const linkedinRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:linkedin.com)\/(\w+)/;
export const facebookRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:facebook.com)\/(\w+)/;
export const twitterRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:twitter.com)\/(\w+)/;
export const githubRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:github.com)\/(\w+)/;
export const stackofRegex = /(?:(?:http|https):\/\/)?(?:www.)?(?:stackoverflow.com)\/(\w+)/;
// export const phoneRegex =
//   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;

import api from 'src/api';
export const isEmailExist = async (values, currentEmail) => {
  if (values === currentEmail) return true;
  try {
    let response = await api(`/emails?email=${values}&isDeleted=false`, null, 'get');
    if (response.emails.length > 0) {
      return false;
    } else {
      return true;
    }
  } catch (error) {}
};

export const daysOfWeek = [
  {
    value: 0,
    label: 'Sun',
  },
  {
    value: 1,
    label: 'Mon',
  },
  {
    value: 2,
    label: 'Tue',
  },
  {
    value: 3,
    label: 'Wed',
  },
  {
    value: 4,
    label: 'Thu',
  },
  {
    value: 5,
    label: 'Fri',
  },
  {
    value: 6,
    label: 'Sat',
  },
];
export const emailRegex = /^(?!.*\.\.)(?!.*--)[^@]+@([a-zA-Z0-9]+[-.]?[a-zA-Z0-9]+)+\.[a-zA-Z]{2,}$/;


export const trialSubscriptionPlansPriceId = [
  'Starter-Monthly-Plan-GBP-Monthly',
  'Trial-plan-7-day-GBP-Weekly',
];

export const trialSubscriptionPlans = [
  'One-Membership-Freemium-Monthly-GBP-Monthly',
  'One-Membership-Trial-Plan-GBP-7-days',
];


const outReachPlans = {
  month: 'Outreach-Monthly-GBP-Monthly',
  year: 'Outreach---Annual-GBP-Yearly',
};

const oneMemberShipPlans = {
  year: 'OneMembership---Annual-GBP-Yearly',
  month: 'OneMembership-Discount-Pricing-GBP-Monthly',
};

const lmsPlans = {
  month: 'LMS---Monthly-GBP-Monthly',
  year: 'LMS---Annual-GBP-Yearly',
};

const starterPlans = {
  month: 'Starter-Monthly-Plan-GBP-Monthly',
};

const free14DaysPlan = {
  month: 'Trial-plan-7-day-GBP-Weekly',
};

export const basicPlans = {
  'Outreach-Monthly-GBP-Monthly': outReachPlans,
  'Outreach---Annual-GBP-Yearly': outReachPlans,
  'OneMembership---Annual-GBP-Yearly': oneMemberShipPlans,
  'OneMembership-Discount-Pricing-GBP-Monthly': oneMemberShipPlans,
  'LMS---Monthly-GBP-Monthly': lmsPlans,
  'LMS---Annual-GBP-Yearly': lmsPlans,
  'Trial-plan-7-day-GBP-Weekly': free14DaysPlan,
  'Starter-Monthly-Plan-GBP-Monthly': starterPlans,
};
